import { get, post, put } from "../../helpers/api_helper";
export const getNotificationListAction = (pageno = 1, limit = 10) => {
  return get(
    `/notification/get-web-notification?page=${pageno}&limit=${limit}`
  );
};
export const updateNotificationReadStatusAction = body => {
  return put(`/notification/update-web-isread`, body);
};
